import { type Asset, type AssetLabel } from "@/entities/asset";

const DEMO_TENANT_ID = "1";

export const mockAssets: Asset[] = [
  // Backstube Zentrale (branch-1)
  {
    id: "asset-1",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-2",
    location_id: "branch-1",
    name: "Etagenofen Wiesheu EBO 86",
    serial_number: "WS-EBO-2019-001",
    asset_number: "AN-001",
    commissioning_date: "2019-03-15",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-2",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-1",
    location_id: "branch-1",
    name: "Etagenofen Wiesheu EBO 64",
    serial_number: "WS-EBO-2020-001",
    asset_number: "AN-002",
    commissioning_date: "2020-06-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-3",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-3",
    location_id: "branch-1",
    name: "Stikkenofen Debag",
    serial_number: "DB-STK-2021-001",
    asset_number: "AN-003",
    commissioning_date: "2021-02-15",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-4",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-4",
    location_id: "branch-1",
    name: "Konvektomat Rational SCC 101",
    serial_number: "RAT-SCC-2020-001",
    asset_number: "AN-004",
    commissioning_date: "2020-08-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-8",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-9",
    location_id: "branch-1",
    name: "SpÃ¼lmaschine Winterhalter PT-L",
    serial_number: "WH-PTL-2019-001",
    asset_number: "AN-008",
    commissioning_date: "2019-03-15",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Filiale Marktplatz (branch-2)
  {
    id: "asset-5",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-6",
    location_id: "branch-2",
    name: "KÃ¼hltheke Nordcap 2500",
    serial_number: "NC-KT-2020-001",
    asset_number: "AN-005",
    commissioning_date: "2020-09-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-6",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-8",
    location_id: "branch-2",
    name: "Kasse Vectron POS Touch",
    serial_number: "VEC-PT-2021-001",
    asset_number: "AN-006",
    commissioning_date: "2021-01-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-7",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-10",
    location_id: "branch-2",
    name: "CafÃ©-Tisch 1",
    serial_number: "CT-2020-001",
    asset_number: "AN-007",
    commissioning_date: "2020-09-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-12",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-5",
    location_id: "branch-2",
    name: "Konvektomat Rational SCC 61",
    serial_number: "RAT-SCC-2022-001",
    asset_number: "AN-012",
    commissioning_date: "2022-03-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Filiale Neckarstadt (branch-3)
  {
    id: "asset-9",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-7",
    location_id: "branch-3",
    name: "TiefkÃ¼hlschrank Liebherr GGPv 6570",
    serial_number: "LH-TK-2021-001",
    asset_number: "AN-009",
    commissioning_date: "2021-04-15",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-10",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-8",
    location_id: "branch-3",
    name: "Kasse Vectron POS Touch",
    serial_number: "VEC-PT-2021-002",
    asset_number: "AN-010",
    commissioning_date: "2021-04-15",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-11",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-6",
    location_id: "branch-3",
    name: "KÃ¼hltheke Nordcap 2000",
    serial_number: "NC-KT-2021-001",
    asset_number: "AN-011",
    commissioning_date: "2021-04-15",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Filiale Ludwigshafen (branch-4)
  {
    id: "asset-13",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-6",
    location_id: "branch-4",
    name: "KÃ¼hltheke Nordcap 2500",
    serial_number: "NC-KT-2019-001",
    asset_number: "AN-013",
    commissioning_date: "2019-08-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-14",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-8",
    location_id: "branch-4",
    name: "Kasse Vectron POS Touch",
    serial_number: "VEC-PT-2019-001",
    asset_number: "AN-014",
    commissioning_date: "2019-08-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Filiale Heidelberg (branch-5)
  {
    id: "asset-15",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-6",
    location_id: "branch-5",
    name: "KÃ¼hltheke Nordcap 3000",
    serial_number: "NC-KT-2022-001",
    asset_number: "AN-015",
    commissioning_date: "2022-01-15",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-16",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-8",
    location_id: "branch-5",
    name: "Kasse Vectron POS Touch",
    serial_number: "VEC-PT-2022-001",
    asset_number: "AN-016",
    commissioning_date: "2022-01-15",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Filiale Weinheim (branch-6)
  {
    id: "asset-17",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-6",
    location_id: "branch-6",
    name: "KÃ¼hltheke Nordcap 2000",
    serial_number: "NC-KT-2020-002",
    asset_number: "AN-017",
    commissioning_date: "2020-05-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-18",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-8",
    location_id: "branch-6",
    name: "Kasse Vectron POS Touch",
    serial_number: "VEC-PT-2020-001",
    asset_number: "AN-018",
    commissioning_date: "2020-05-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Filiale Schwetzingen (branch-7)
  {
    id: "asset-19",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-6",
    location_id: "branch-7",
    name: "KÃ¼hltheke Nordcap 2500",
    serial_number: "NC-KT-2023-001",
    asset_number: "AN-019",
    commissioning_date: "2023-03-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-20",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-8",
    location_id: "branch-7",
    name: "Kasse Vectron POS Touch",
    serial_number: "VEC-PT-2023-001",
    asset_number: "AN-020",
    commissioning_date: "2023-03-01",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Vorlagen: Verkaufsfiliale Standard (branch-template-1)
  {
    id: "asset-t1-1",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-6",
    location_id: "branch-template-1",
    name: "[Vorlage] KÃ¼hltheke",
    serial_number: "",
    asset_number: "TPL-001",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-t1-2",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-8",
    location_id: "branch-template-1",
    name: "[Vorlage] Kassensystem",
    serial_number: "",
    asset_number: "TPL-002",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-t1-3",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-10",
    location_id: "branch-template-1",
    name: "[Vorlage] CafÃ©-Tisch",
    serial_number: "",
    asset_number: "TPL-003",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Vorlagen: Backstube (branch-template-2)
  {
    id: "asset-t2-1",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-1",
    location_id: "branch-template-2",
    name: "[Vorlage] Etagenofen",
    serial_number: "",
    asset_number: "TPL-010",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-t2-2",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-4",
    location_id: "branch-template-2",
    name: "[Vorlage] Konvektomat",
    serial_number: "",
    asset_number: "TPL-011",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "asset-t2-3",
    accountId: DEMO_TENANT_ID,
    asset_model_id: "model-9",
    location_id: "branch-template-2",
    name: "[Vorlage] SpÃ¼lmaschine",
    serial_number: "",
    asset_number: "TPL-012",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const demoAssets = mockAssets;

export const demoAssetLabels: AssetLabel[] = [
  { id: "al-1", asset_id: "asset-1", label_id: "lbl-1", createdAt: new Date() },
  { id: "al-2", asset_id: "asset-2", label_id: "lbl-1", createdAt: new Date() },
  { id: "al-3", asset_id: "asset-4", label_id: "lbl-2", createdAt: new Date() },
  { id: "al-4", asset_id: "asset-5", label_id: "lbl-4", createdAt: new Date() },
  { id: "al-5", asset_id: "asset-8", label_id: "lbl-7", createdAt: new Date() },
  { id: "al-6", asset_id: "asset-9", label_id: "lbl-5", createdAt: new Date() },
  { id: "al-7", asset_id: "asset-1", label_id: "lbl-11", createdAt: new Date() },
  { id: "al-8", asset_id: "asset-19", label_id: "lbl-12", createdAt: new Date() },
];
import { type AssetCategory } from "@/entities/asset";

export const mockAssetCategories: AssetCategory[] = [
  {
    id: "cat-1",
    accountId: "1",
    name: "BackÃ¶fen",
    description: "Professionelle BackÃ¶fen fÃ¼r BÃ¤ckereien",
    sortingOrder: 1,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "cat-2",
    accountId: "1",
    name: "Konvektomaten",
    description: "KombidÃ¤mpfer und KonvektionsÃ¶fen",
    sortingOrder: 2,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "cat-3",
    accountId: "1",
    name: "KÃ¼hlgerÃ¤te",
    description: "KÃ¼hlschrÃ¤nke, TiefkÃ¼hler und KÃ¼hltheken",
    sortingOrder: 3,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "cat-4",
    accountId: "1",
    name: "Kassensysteme",
    description: "POS-Systeme und Registrierkassen",
    sortingOrder: 4,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "cat-5",
    accountId: "1",
    name: "SpÃ¼lmaschinen",
    description: "Gewerbliche SpÃ¼lmaschinen",
    sortingOrder: 5,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "cat-6",
    accountId: "1",
    name: "Tischgarnituren",
    description: "Tische, StÃ¼hle und SitzmÃ¶bel",
    sortingOrder: 6,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
import { type AssetModel } from "@/entities/asset";

export const mockAssetModels: AssetModel[] = [
  // BackÃ¶fen
  {
    id: "model-1",
    accountId: "1",
    assetCategoryId: "cat-1",
    status: "ACTIVE",
    name: "Backofen Standard 80kW",
    description: "Standard-Backofen fÃ¼r mittlere Produktionsmengen",
    manufacturer: "Wiesheu",
    voltage: 400,
    powerKw: 80,
    frequencyHz: 50,
    current: 125,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "model-2",
    accountId: "1",
    assetCategoryId: "cat-1",
    status: "ACTIVE",
    name: "Backofen Pro 120kW",
    description: "Profi-Backofen fÃ¼r hohe Produktionsmengen",
    manufacturer: "Wiesheu",
    voltage: 400,
    powerKw: 120,
    frequencyHz: 50,
    current: 190,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "model-3",
    accountId: "1",
    assetCategoryId: "cat-1",
    status: "ACTIVE",
    name: "Backofen Kompakt 40kW",
    description: "Kompakter Backofen fÃ¼r kleine Filialen",
    manufacturer: "Debag",
    voltage: 400,
    powerKw: 40,
    frequencyHz: 50,
    current: 65,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Konvektomaten
  {
    id: "model-4",
    accountId: "1",
    assetCategoryId: "cat-2",
    status: "ACTIVE",
    name: "Konvektomat 10 EinschÃ¼be",
    description: "KombidÃ¤mpfer mit 10 EinschÃ¼ben",
    manufacturer: "Rational",
    voltage: 400,
    powerKw: 18,
    frequencyHz: 50,
    current: 32,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "model-5",
    accountId: "1",
    assetCategoryId: "cat-2",
    status: "ACTIVE",
    name: "Konvektomat 6 EinschÃ¼be",
    description: "Kompakter KombidÃ¤mpfer mit 6 EinschÃ¼ben",
    manufacturer: "Rational",
    voltage: 400,
    powerKw: 11,
    frequencyHz: 50,
    current: 20,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // KÃ¼hlgerÃ¤te
  {
    id: "model-6",
    accountId: "1",
    assetCategoryId: "cat-3",
    status: "ACTIVE",
    name: "KÃ¼hltheke 2m",
    description: "KÃ¼hltheke fÃ¼r Verkaufsbereich, 2 Meter",
    manufacturer: "Nordcap",
    voltage: 230,
    powerKw: 0.8,
    frequencyHz: 50,
    current: 4,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "model-7",
    accountId: "1",
    assetCategoryId: "cat-3",
    status: "ACTIVE",
    name: "TiefkÃ¼hlschrank 600L",
    description: "Gewerblicher TiefkÃ¼hlschrank",
    manufacturer: "Liebherr",
    voltage: 230,
    powerKw: 0.5,
    frequencyHz: 50,
    current: 2.5,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Kassensysteme
  {
    id: "model-8",
    accountId: "1",
    assetCategoryId: "cat-4",
    status: "ACTIVE",
    name: "Kasse Touch Pro",
    description: "Touchscreen-Kassensystem mit integriertem Drucker",
    manufacturer: "Vectron",
    voltage: 230,
    powerKw: 0.1,
    frequencyHz: 50,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // SpÃ¼lmaschinen
  {
    id: "model-9",
    accountId: "1",
    assetCategoryId: "cat-5",
    status: "ACTIVE",
    name: "DurchschubspÃ¼ler Standard",
    description: "Gewerbliche DurchschubspÃ¼lmaschine",
    manufacturer: "Winterhalter",
    voltage: 400,
    powerKw: 8,
    frequencyHz: 50,
    current: 14,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Tischgarnituren
  {
    id: "model-10",
    accountId: "1",
    assetCategoryId: "cat-6",
    status: "ACTIVE",
    name: "CafÃ©-Tisch rund 80cm",
    description: "Runder CafÃ©-Tisch aus Holz",
    manufacturer: "Gastronomie MÃ¶bel GmbH",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "model-11",
    accountId: "1",
    assetCategoryId: "cat-6",
    status: "ACTIVE",
    name: "Stuhl Klassik",
    description: "Holzstuhl fÃ¼r CafÃ©-Bereich",
    manufacturer: "Gastronomie MÃ¶bel GmbH",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
